import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { SolarConcertSellerReadinessDto } from "../dto/solar-concert.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * Whether the seller (or mentor) has an onboarded Concert user, with a
 * license in California: V1's account gate. A live Concert read, so it is
 * shared for a minute rather than repeated on every open.
 */
export default function useSolarConcertSellerReadiness(
  proposalId: string | undefined,
): UseQueryResult<SolarConcertSellerReadinessDto> {
  return useQuery({
    queryKey: queryKeys.solarProposal.concertSellerReadiness(proposalId ?? ``),
    queryFn: () =>
      solarProposalService.getConcertSellerReadiness(proposalId ?? ``),
    enabled: Boolean(proposalId),
    retry: 1,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  })
}
